module.exports = __webpack_public_path__ + "static/media/without-team-icon.8d6524a7.svg";